import React, { useState, useEffect, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Auth from '../../../store/auth/actions';
import ButtonBase from '@material-ui/core/ButtonBase';
import Page from '../../atoms/page';
import ForgotPassword from './forgotPassword'
import PasswordReset from './passwordReset';
import config from '../../../config';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import { validateEmail } from '../../../config/validations';
import FullPageLoader from '../../atoms/fullPageLoader';
import { handleSnackBar } from '../../../store/global/actions';
import { useHistory } from "react-router-dom";

function Copyright() {
  return (
    <Typography id={"copyright_link"} variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://hyperblox.io/">
        HyperBlox
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    // backgroundImage: 'url(https://source.unsplash.com/random)',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#486583' || '#34495e',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paperWrapper: {
    margin: theme.spacing(8, 4),
    // height: 200,
    width: 600,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
    textTransform: "capitalize"
    
  },
  logoDiv: {
    marginTop: '35%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    height: 80,
    paddingLeft: '10%',
  },
  loginWrapper: {
    backgroundColor: '#486583' || '#34495e',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: '#f5f5f5' || '#34495e',
  },
  subtitle: {},
}));

export default function SignInSide() {

  const classes = useStyles();

  const { register, handleSubmit, reset, formState: { errors }, getValues, watch } = useForm({});
  const dispatch = useDispatch();
  const history = useHistory();
  const hostname = window.location.hostname;
  const port = window.location.port;
  const API_URL = config.apiUrl;

  const [isSignUp, setIsSignUp] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [openReset, setOpenReset] = useState(false);
  const [userData, setUserData] = useState('');
  const [isLoader, setIsLoader] = useState(false);
  const [isFullPageLoader, setIsFullPageLoader] = useState(false);
  const [showResendLink, setShowResendLink] = useState(false);
  const [userNameForEmailVerify, setUserNameForEmailVerify] = useState("");
  const toggleSignIn = () => setIsSignUp((prev) => !prev);

 
  const messages = { validate: 'New password and confirm password does not match', required: 'Field is required', emailValidation: 'Email Address is invalid' };
  const newPassword = watch('password');

  useEffect(() => {
    let url = window.location;
    if(url?.pathname === '/reset-password') {
      setIsFullPageLoader(true)
      checkResetToken();
    }
    if(url?.pathname === '/verify-email') {
      verifyEmail();
    }
    const isSessionTimeOut = localStorage.getItem("isSessionTimeOut");
    if(isSessionTimeOut && isSessionTimeOut === "true") {
      localStorage.removeItem("isSessionTimeOut");
      dispatch(handleSnackBar({ open: true, message: `Session timed out. Please login`, severity: 'error' }));
    }
  }, []);

  const checkResetToken = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    const tokenPayload = { token: params.token }

    const response = axios({
      method: 'post',
      url: API_URL + 'user/getUser',
      data: tokenPayload,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.data) {
        setIsFullPageLoader(false);
        setUserData(response.data?.user);
        setOpenReset(true);

      }
    });
  }

  const verifyEmail = () => {
    try {
      
    
    setIsFullPageLoader(true);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const tokenPayload = { token: params.token, username: params.username }
    setUserNameForEmailVerify(params.username);
    axios({
      method: 'post',
      url: API_URL + 'user/verify',
      data: tokenPayload,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      setIsFullPageLoader(false);
      if (response.data?.status == true) {
        dispatch(handleSnackBar({ open: true, message: response.data?.message, severity: 'success' }));
        setShowResendLink(false);
      }
    }).catch((error) => {
      setIsFullPageLoader(false);
      if (error.response) {
        console.error("Error response:", error.response);
        const { status, data } = error.response;
        if (data.isEmailVerified == true) {
          setShowResendLink(false);
        } else {
          setShowResendLink(true);
        }
        dispatch(handleSnackBar({ open: true, message: data?.message ? data?.message : "Email verification failed", severity: 'error' }));
      } else {
        console.error("Error verifying email:", error.message);
        setShowResendLink(true);
        dispatch(handleSnackBar({ open: true, message: "Email verification failed", severity: 'error' }));
      }
    });

    } catch (error) {
      console.error(`Verify email failed. ${error}`);
    }
  }

  const resendEmailVerification = () => {
    try {
      
    axios({
      method: 'post',
      url: API_URL + 'user/email-verify/resend',
      data: {username: userNameForEmailVerify, hostname, port},
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.data?.status === true) {
        dispatch(handleSnackBar({ open: true, message: response.data?.message, severity: 'success' }));
      }else{
        dispatch(handleSnackBar({ open: true, message: `${response?.data?.message && response?.data?.message != "" ? response?.data?.message  : "Resend verification email failed"}`, severity: 'error' }));
      }
    }).catch((error) => {
      if (error.response) {
        console.error("Error response:", error.response);
        const { status, data } = error.response;
        dispatch(handleSnackBar({ open: true, message: data?.message ? data?.message : "Resend Verification email failed", severity: 'error' }));
      } else {
        console.error("Error resending email:", error.message);
        dispatch(handleSnackBar({ open: true, message: "Resend verification email failed", severity: 'error' }));
      }
    });

    } catch (error) {
      console.error(`Resend email verification failed. ${error}`);
    }
  }

  const closeForgotPassword = () => {
    setIsForgotPassword(false);
  }

  const comparePassword = (confirmPassword) => {
    if (newPassword !== confirmPassword)
      return false
  }

  const onSubmitUserData = (data) => {
    try {
      setIsLoader(true);
      if (!isSignUp) {
          history.push("/");
          dispatch(Auth.login(data)).then((response)=> {
          setIsLoader(false);
          
          if (response && response.isEmailVerified === false) {
            setUserNameForEmailVerify(data.username);
            setShowResendLink(true);
          } else {
            setShowResendLink(false);
          }
        });
      } else {
        dispatch(Auth.register({...data, hostname, port})).then((data) => {
          setIsLoader(false);
          if (data?.username !== undefined) {
            toggleSignIn();
            reset({ defaultValues: { username: 'vipin@hyperblox.io', password: 'some' } })
          } 

          //toggleSignIn();
        });
      }

    } catch (error) { 
      console.error(`Submitting user data failed. ${error}`);
      console.log({data});
    }
  };

  return (
    isFullPageLoader ? 
    <FullPageLoader open={isFullPageLoader} />
    :
    <Page padding={0} title={isSignUp ? 'Register' : 'Login'}>
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={6} className={classes.image} id={"hyperblox_logo_container"}>
          <Grid className={classes.logoDiv}>
            <img id={"hyperblox_logo"} className={classes.logo} src="../../../../../main-logo.png" alt="Hyperblox Logo" />
            {/* <Typography style={{color: '#fff'}} variant="h6">
              Bringing the web-app approach to telecoms HyperBlox is pioneering a framework to make development, deployment and management of telecom applications as simple as web applications
            </Typography> */}
          </Grid>
        </Grid>
        <Grid item className={classes.loginWrapper} id={"login_form_container"} xs={12} sm={8} md={6}>
          <div className={`${classes.paperWrapper} _paper-wrapper`}>
            <Paper className={`${classes.paper} _paper-white`} elevation={6}>
              {/* <form onSubmit={handleSubmit(onSubmit)} className={classes.form} noValidate> */}
              {isForgotPassword == '' && openReset == false && <>
                <Grid container direction={"row"} spacing={3} >
                  <Grid item xs={6}>
                    {isSignUp ? <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="fname"
                      label="First Name"
                      name="fname"
                      autoComplete="fname"
                      autoFocus
                      inputRef={register({ required: true })}
                      error={errors?.fname ? true : false}
                      helperText={errors?.fname ? messages.required : ''}
                    /> : null}
                  </Grid>

                  <Grid item xs={6}>
                    {isSignUp ? <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="lname"
                      label="Last Name"
                      name="lname"
                      autoComplete="lname"
                      inputRef={register({ required: true })}
                      error={errors?.lname ? true : false}
                      helperText={errors?.lname ? messages.required : ''}
                    /> : null}
                  </Grid>
                </Grid>

                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="username"
                  label="Email Address"
                  name="username"
                  autoComplete="username"
                  autoFocus
                  inputRef={register({ required: true, validate: validateEmail })}
                  error={errors?.username ? true : false}
                  helperText={getValues('username') == '' && errors?.username ?  messages.required :  errors?.username ? messages.emailValidation : ''}
                />

                {isSignUp ? <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="companyName"
                  label="Company Name"
                  name="companyName"
                  autoComplete="companyName"
                  inputRef={register({ required: true })}
                  error={errors?.companyName ? true : false}
                  helperText={errors?.companyName ? messages.required : ''}
                /> : null}

                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  inputRef={register({ required: true })}
                  error={errors?.password ? true : false}
                  helperText={errors?.password ? messages.required : ''}
                />

                {isSignUp ? <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                  id="confirmPassword"
                  //inputRef={register({ required: true })}
                  inputRef={register({ required: true, validate: comparePassword })}
                  error={errors?.confirmPassword ? true : false}
                  helperText={getValues('confirmPassword') === '' && errors?.confirmPassword ? messages.required :  errors?.confirmPassword ? messages[errors?.confirmPassword?.type] : ''}
                /> : null}

                <Grid container direction={"row"} spacing={2} alignItems="center" >
                  <Grid item xs={8} style={{ marginLeft: 3 }}>
                    {isSignUp ? null : <FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />}
                  </Grid>

                  <Grid item xs style={{ display: 'flex', justifyContent: 'end' }}>
                    {!isSignUp && !showResendLink &&  <Link href='#' onClick={() => setIsForgotPassword(true)}>
                      Forgot Password?
                    </Link>}
                    {!isSignUp && showResendLink && <Link id="resendLink" href='#' onClick={resendEmailVerification}>
                      Resend Verification Email
                      </Link>
                    }
                  </Grid>

                </Grid>

                <Button onClick={handleSubmit(onSubmitUserData)}  fullWidth variant="contained" disabled={ isLoader ? true : false } color="primary" className={`${classes.submit} _paper-submit-button`} startIcon={isLoader ? <CircularProgress size={20} style={{color: '#000'}} /> : <Fragment /> }>
                  {isSignUp ? 'Sign Up' : 'Sign In'}
                </Button>

                <Grid container>
                  <Grid item xs>
                    {/* <a href="https://builder.hyperblox.io/docs/" title="Hyperblox builder documentation" target="_blank">View Documentation</a> */}
                    <a href="/docs/getting-started/" title="Hyperblox builder documentation" target="_blank" > View Documentation </a>
                  </Grid>
                  <Grid item>
                    {isSignUp ? (
                      <ButtonBase variant="body2" >
                        {'Already have account? '} &nbsp;
                        <Link href='#' onClick={() => toggleSignIn(null)} >
                        Sign In
                        </Link>
                      </ButtonBase>
                    ) : (
                      <ButtonBase variant="body2" >
                        {`Don't have an account?`} &nbsp;
                        <Link href='#' onClick={() => toggleSignIn(null)} >
                          Sign Up
                        </Link>
                      </ButtonBase>
                    )}
                  </Grid>
                </Grid>
              </>}
              {isForgotPassword && <ForgotPassword onCancel={closeForgotPassword} />}
              {openReset && <PasswordReset onCancel={() => setOpenReset(false)} userData={userData} />}
              <Box mt={5}>
                <Copyright />
              </Box>
              {/* </form> */}
            </Paper>
          </div>
        </Grid>
      </Grid>
    </Page>
  );
}
